module.exports = __webpack_public_path__ + "img/map-7.994c1902.svg";